/* eslint-disable prefer-const */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import useLookupModule from '../../../../hooks/Lookups/use-Lookup-Module';
import { Card, CardBody } from '../../../../components/card/card';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { ChangeNotificationActive, GetNotificationList } from '../../../../store/NTX/Notifications/notificationSlice';
import showConfirmation from '../../../../components/Shared/Alert/Confirmation';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { type NotificationListModal } from '../../../../store/NTX/Notifications/notificationModels';
import Loading from '../../../../components/Shared/Loader/Loading';
import { usePermissions } from '../../../../Helper/Permisstions/usePermissions';
import NtxTable from '../../../../components/DataTable/NtxTable.jsx';

interface LookupModule {
  Module: any[];
}

function Index() {
  const { HasPermission } = usePermissions();
  const { t, i18n } = useTranslation();
  const [search, setSearch] = useState<string>('');

  const Navigate = useNavigate();
  const dispatch = useAppDispatch();

  //__________________________________________________
  const { NotificationsList, loading, changeActiveloading, error } = useAppSelector(state => state.Notifications);
  useEffect(() => {
    if (NotificationsList?.length === 0) {
      dispatch(GetNotificationList());
    }
  }, [dispatch]);

  const [selectedValue, setSelectedValue] = useState(null);

  const { Module }: LookupModule = useLookupModule();

  //_________________________________________________________________________________________________

  const filteredSearch = NotificationsList?.slice()
    ?.filter(item => {
      const searchLowerCase = search.toLowerCase();
      return (
        item.name?.toLowerCase().includes(searchLowerCase) ||
        item.name2?.toLowerCase().toString().includes(searchLowerCase)
      );
    })
    ?.filter(f => (selectedValue === null ? true : f.moduleId === selectedValue));

  const columns = [
    { title: t('NotificationName'), key: 'Name' },
    { title: t('NotificationIcon'), key: 'Icon' },
    { title: t('TypeNotification'), key: 'Type' },
    { title: t('NotificationStatus'), key: 'Status' },

    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = filteredSearch?.map(item => {
    let rowClass;

    return {
      Name: i18n.language === 'ar' ? item.name2 : item.name,
      Icon: (
        <div className='text-theme fs-3 '>
          <i className={item.icon}></i>
        </div>
      ),
      Type: (
        <div className=' fs-3'>
          <i
            className={`bi bi-envelope-at mx-2 text-${item.sendEmail ? 'theme ' : 'light  opacity-3'}`}
            style={{ borderBottom: '2px solid black' }}
          ></i>

          <i className={`bi bi-chat-left-dots mx-2  text-${item.sendSMS ? 'theme' : 'light  opacity-3'}`}></i>

          <i className={`bi bi-whatsapp mx-2 text-${item.sendWhatsApp ? 'theme' : 'light opacity-3'}`}></i>

          <i
            className={`bi bi-bell mx-2 text-${item.pushNotification ? 'theme' : 'light  opacity-3'}`}
            style={{ borderBottom: '2px solid black' }}
          ></i>
        </div>
      ),
      Status: item.isActive ? (
        <span className='text-center badge d-block rounded-0 pt-5px w-70px bg-success text-theme-900'>
          {t('isActive')}
        </span>
      ) : (
        <span className=' text-center badge d-block rounded-0 pt-5px w-70px bg-secondary  '>{t('InActive')}</span>
      ),

      action: (
        <div className='btn-group'>
          {HasPermission('NtxEnableNotifications') && (
            <button
              disabled={changeActiveloading}
              type='button'
              className='btn btn-outline-theme'
              onClick={() => handleChangeNotificationActive(item)}
            >
              {changeActiveloading ? <div className=''></div> : null}
              {item.isActive ? t('TurnOffNotification') : t('ActiveNotification')}
            </button>
          )}
          {HasPermission('NtxEditNotifications') && (
            <button
              className='btn btn-outline-theme'
              // onClick={() => Navigate(`${item.notificationId}/UpdateNotifications`)}
              onClick={() => {
                const newLocation = `/NTF/Notifications/${item.notificationId}/UpdateNotifications`;
                window.location.href = newLocation;
              }}
            >
              <i className='  bi bi-pencil-fill fa-fw me-1'></i>
              {t('EditNotification')}
            </button>
          )}
        </div>
      ),

      rowClass // استخدم rowClass هنا
    };
  });

  // NotificationListModal
  const handleChangeNotificationActive = async (item: NotificationListModal) => {
    let msg = item.isActive ? t('NoticNessage1') : t('NoticNessage2');
    showConfirmation(msg, async () => {
      try {
        const res = await dispatch(ChangeNotificationActive({ notificationId: item.notificationId })).unwrap();

        if (res.succeeded === true) {
          CustomAlert({ action: 'Add', msg: 'نجحت العملية' });
          dispatch(GetNotificationList());
        } else {
          CustomAlert({ action: 'Error' });
        }
      } catch (err) {
        CustomAlert({ action: 'Error' });
        // handle error here
      }
    });
  };

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: t('NotificationsManagement'),
              link: null
            }
          ]}
          PageName={t('NotificationsManagement')}
        />

        {HasPermission('NtxAddNotifications') && (
          <div className='ms-auto'>
            <button className='btn btn-theme' onClick={() => Navigate(`/NTF/Notifications/AddNotifications`)}>
              <i className='fa fa-plus-circle fa-fw me-1'></i>
              {t('NewNotification')}
            </button>
          </div>
        )}
      </div>
      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <div className='row'>
              <div className='col-xl-6'>
                <div className='input-group flex-nowrap mb-2'>
                  <span className='input-group-text'>{t('Application')}</span>
                  <Select
                    classNamePrefix='react-select'
                    className='w-100'
                    isSearchable={true}
                    isClearable
                    options={
                      Module &&
                      Module?.map((item: any) => ({
                        value: item.id,
                        label: i18n.language === 'ar' ? item.name2 : item.name
                      }))
                    }
                    onChange={(option: any) => {
                      setSelectedValue(option === null ? null : option.value);
                    }}
                    placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  />
                </div>
              </div>
              <div className='col-xl-6'>
                <div className='input-group flex-nowrap mb-2'>
                  <span className='input-group-text'>{t('Search')}</span>
                  <input
                    type='text'
                    autoComplete='off'
                    className='form-control '
                    onChange={e => {
                      setSearch(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>

            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              searchColumns={undefined}
            />
          </CardBody>
        </Loading>
      </Card>
    </>
  );
}

export default Index;
